import { BehaviorContext } from '../../behavior-context';
import { Behavior } from '../../behavior';
import {
  SESSION_KEY_LEASE_APPLICATION,
  GLOBAL_CONTEXT_KEY_APP_RESULT,
  GLOBAL_CONTEXT_KEY_APPROVAL_AMOUNT,
} from './constants';
import { Injectable } from '@angular/core';

@Injectable()
export class SubmitApplicationBehavior implements Behavior {
  async execute(args: any, context: BehaviorContext): Promise<any> {
    // Temporarily retrieve in session storage
    const applicationData = JSON.parse(
      sessionStorage.getItem(SESSION_KEY_LEASE_APPLICATION)
    );

    // Todo: front-end validation

    // Temporary mock request

    const result: any = await new Promise((res, rej) => {
      setTimeout(() => {
        res({
          status: 'approved',
          accountNumber: 12345678,
          approvalLimit: 2500,
          errorMessage: null,
        });
      }, 5000);
    });

    context.set(GLOBAL_CONTEXT_KEY_APP_RESULT, result);
    context.set(GLOBAL_CONTEXT_KEY_APPROVAL_AMOUNT, result.approvalLimit);
  }
}
